import { render, staticRenderFns } from "./FourthStepWizzard.vue?vue&type=template&id=44e1b33b&scoped=true&"
import script from "./FourthStepWizzard.vue?vue&type=script&lang=js&"
export * from "./FourthStepWizzard.vue?vue&type=script&lang=js&"
import style0 from "./FourthStepWizzard.vue?vue&type=style&index=0&id=44e1b33b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1b33b",
  null
  
)

export default component.exports